export const DEFAULTLST = [
  'wind',
  'ocean',
  'space',
  'earth',
  'wallpaper',
  'poster',
  'gundam',
  'fireworks',
  'winter',
  'landscape',
  'robot',
];
